import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M7.69 11.316V6.895h.91v4.42h-.91zM7.548 5.28a.59.59 0 01.594-.597c.335 0 .604.265.604.597a.59.59 0 01-.604.587.582.582 0 01-.594-.587z" fill="currentcolor"/><path d="M8.284 6.895h-2.21v.737h2.21v-.737z" fill="currentcolor"/><circle stroke="currentcolor" transform="translate(8 8)" r="7"/></svg>`;

export { symbol as default };
